import React from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Header from "./Header";
import { ILayout } from "../interfaces/shared/ILayout";
import { useIncidentAlerts } from "../hooks/useIncidentAlerts";

interface IProps {
  children: React.JSX.Element;
  routes?: ILayout[] | undefined;
}

const Layout = ({ children, routes }: IProps) => {
  useIncidentAlerts();
  const sidebarItems = (routes || []).filter((r) => r.showInSidebar);
  const hasSidebar = sidebarItems.length > 0;

  return (
    <>
      {hasSidebar && <Sidebar routes={routes} />}
      <Header hasSidebar={hasSidebar} />
      <div className={`pc-container ${!hasSidebar ? "no-sidebar" : ""}`}>
        <div className={"pc-content "}>{children}</div>
      </div>
      <Footer />
      {!hasSidebar && (
        <style>
          {`
            .pc-header { left: 0 !important; width: 100% !important; }
            .pc-container { margin-left: 0 !important; }
          `}

        </style>
      )}
    </>
  );
};



export default Layout;
